import { p11n } from '@ucheba/utils/helpers/string'
import { getFullRouterPath, objectToQueryString } from '@ucheba/utils/helpers/router'

export const getLinkProps = ({
  id,
  subjects,
  programCount,
}): {
  name: string
  href: string
} => {
  return {
    name: `${programCount} ${p11n(
      programCount || 0,
      'программа',
      'программы',
      'программ'
    )}`,
    href: getFullRouterPath(
      `/uz/${id}/programs`,
      objectToQueryString({
        examSubjectIds: subjects.map((item) => item.id),
        sectionType: 1002,
      })
    ),
  }
}
